import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import "./LoadingService.scss";

interface IContext {
  getBlockUI: string
  setBlockUI: (content?: string) => void;
}
const Context = createContext<IContext>(null);

export function useLoading() {
  const context = useContext(Context);
  if (!context) {
    throw new Error("LoadingService 未初始化！");
  }
  return context;
}

/** 讀取中指示器 */
export const LoadingService = ({ children }) => {
  const [text, setText] = useState<string>("");
  const setBlockUI = useCallback((content?: string) => {
    setText(content);
  }, []);
  const context: IContext = useMemo(
    () => ({
      getBlockUI: text,
      setBlockUI,
    }),
    [setBlockUI, text]
  );
  return (
    <Context.Provider value={context}>
      {children}
      <div className={"loading-dimmer " + (text ? "active" : "")}>
        <div id="html-spinner"></div>
      </div>
    </Context.Provider>
  );
};
